// Up to three saved configurations per product for side-by-side comparison (browser-local).
const KEY = (productType) => `apollo-design-compare:${productType}`;
export const MAX_COMPARE = 3;

export const readCompareDesigns = (productType) => {
  try {
    const raw = localStorage.getItem(KEY(productType));
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
};

export const writeCompareDesigns = (productType, list) => {
  try {
    localStorage.setItem(KEY(productType), JSON.stringify(list.slice(0, MAX_COMPARE)));
  } catch (e) {
    /* ignore */
  }
};
